import React from 'react';
import PropTypes from 'prop-types';

const ThreeDotsIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '5px';
  const h = (height) ? height.toString().concat('px') : '18px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 5 18"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 -3.91405e-08 2 -8.74228e-08C0.895431 -1.35705e-07 -3.91405e-08 0.89543 -8.74228e-08 2C-1.35705e-07 3.10457 0.89543 4 2 4ZM4 9C4 10.1046 3.10457 11 2 11C0.89543 11 -4.41685e-07 10.1046 -3.93402e-07 9C-3.4512e-07 7.89543 0.89543 7 2 7C3.10457 7 4 7.89543 4 9ZM4 16C4 17.1046 3.10457 18 2 18C0.89543 18 -7.47665e-07 17.1046 -6.99382e-07 16C-6.511e-07 14.8954 0.89543 14 2 14C3.10457 14 4 14.8954 4 16Z"
        fill={(fill) || '#FF5F14'}
      />
    </svg>
  );
};

ThreeDotsIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ThreeDotsIcon;
